<div class="card-header bg-white border-0">
    <div class="row align-items-center" *ngIf="show_title">
        <div class="col-12">
            <h3 class="mb-0">Liste des {{custom_page.title}} ( {{ count_items }} )</h3>
            <p *ngIf="sub_title != ''">{{ sub_title }}</p>
        </div>
        <div class="col-12 text-right">
            <button type="button" class="btn btn-xl btn-dark" (click)="back()" *ngIf="show_back_button"><i
                    class="fa fa-angle-left"></i> Retour</button>
            <button class="btn btn-xl btn-studiomap" *ngIf="show_add_button"
                [routerLink]="['/'+custom_page.endpoint+'/ajouter']">Ajouter</button>
            <button *ngFor="let item_button of custom_buttons" class="{{ item_button.class }}" type="button"
                (click)="actionCustomButtons(item_button)"><span [innerHTML]="item_button.text"></span></button>
        </div>
    </div>
    <div class="row align-items-center mt-3">
        <div class="col-4">
            <div class="form-group row" *ngIf="show_pagination">
                <div class="col-sm-4">
                    <select class="form-control" [ngModel]="limit" (change)="change_limit($event.target.value)">
                        <option value="4">4</option>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <label class="col-sm-8 col-form-label ml-0 pl-0">Entrées par page</label>
            </div>
        </div>
        <div class="col-4"></div>
        <div class="col-4 text-right">
            <form [formGroup]='searchForm' *ngIf="show_search_input">
                <div class="form-group">
                    <input type="text" class="form-control" placeholder="Rechercher..." formControlName="searchInput"
                        (keyup.enter)="do_search()">
                </div>
            </form>
        </div>
    </div>
</div>
<div class="table-responsive">
    <table class="table align-items-center table-flush">
        <thead class="thead-light">
            <tr>
                <th scope="col" *ngFor="let element of columns">
                    <span *ngIf="element.type != 'enum' && !check_order_by(element)">{{ element.value }}</span>
                    <div class="table-column-order" *ngIf="element.type != 'enum' && check_order_by(element)" (click)="click_filter(element)">
                        <span class="mr-2">{{ element.value }}</span>
                        <i class="fa fa-solid fa-sort fa-lg"></i>
                    </div>
                    <select class="form-control" *ngIf="element.type == 'enum'"
                        (change)="change_filters(element ,$event)" [(ngModel)]="element.selected">
                        <option value="{{ item.value }}" *ngFor="let item of element.list">{{ item.text }}</option>
                        <option value="">Tous</option>
                    </select>
                    <select class="form-control" *ngIf="element.type == 'relation-list-with-filter'"
                        (change)="change_filters(element ,$event)" [(ngModel)]="element.selected">
                        <option value="{{ item }}" *ngFor="let item of element.list">{{ item }}</option>
                        <option value="">Tous</option>
                    </select>
                </th>
                <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of results" [ngStyle]="setBgRowTable(item)">
                <td *ngFor="let element of columns">
                    <app-custom-col-table [item]="item" [element]="element"></app-custom-col-table>
                </td>
                <td class="text-right">
                    <!-- call actions buttons -->
                    <app-actions-table [index]="index" [row]="item" [visible_actions]="visible_actions"
                        [invisible_actions]="invisible_actions" [endpoint]="custom_page.endpoint"
                        [show_delete_button]="show_delete_button" [show_edit_button]="show_edit_button"
                        [multi_actions]="multi_actions"
                        [actions_with_condition]="actions_with_condition"></app-actions-table>
                </td>
            </tr>
        </tbody>
    </table>
</div>


<p class="text-center font-weight-bold mt-3" *ngIf="loading">Chargement...</p>
<p class="text-center font-weight-bold mt-3" *ngIf="results.length == 0 && !loading">Aucun élément trouvé</p>
<!-- Call pagination -->
<div class="card-footer py-4" *ngIf="results.length > 0 && !loading && nbr_pages > 1 && show_pagination">
    <nav aria-label="...">
        <ul class="pagination justify-content-end mb-0">
            <li class="page-item">
                <button class="page-link" href="javascript:void(0)" tabindex="-1" (click)="go_to_page(custom_page.route,generate_route_query(previous()))">
                    <i class="fas fa-angle-left"></i>
                    <span class="sr-only">Previous</span>
                </button>
            </li>
            <li class="page-item {{ (current_page == page) ? 'active' : '' }}" *ngFor="let page of pageNums">
                <button class="page-link" href="javascript:void(0)" *ngIf="checkIsNumber(page)" (click)="go_to_page(custom_page.route,generate_route_query(page))">{{ page }}</button>
                <span class="page-link" *ngIf="!checkIsNumber(page)">...</span>
            </li>
            <li class="page-item">
                <button class="page-link" href="javascript:void(0)" (click)="go_to_page(custom_page.route,generate_route_query(next()))">
                    <i class="fas fa-angle-right"></i>
                    <span class="sr-only">Next</span>
                </button>
            </li>
        </ul>
    </nav>
</div>